import StandardContainer from './StandardContainer';


export default StandardContainer;
